import { createFeatureSelector, createSelector } from '@ngrx/store';

import {
  NOTIFICATIONS_FEATURE_KEY,
  NotificationsState,
} from './notifications.reducer';

export const selectNotificationsState =
  createFeatureSelector<NotificationsState>(NOTIFICATIONS_FEATURE_KEY);

export const selectNotifications = createSelector(
  selectNotificationsState,
  state => state.items
);

export const selectUnreadCount = createSelector(
  selectNotificationsState,
  state => state.unreadCount
);

export const selectNotificationsHydrated = createSelector(
  selectNotificationsState,
  state => state.hydrated
);

export const selectNotificationsLoading = createSelector(
  selectNotificationsState,
  state => state.loading
);

export const selectNotificationsLoadingMore = createSelector(
  selectNotificationsState,
  state => state.loadingMore
);

export const selectNotificationsPagination = createSelector(
  selectNotificationsState,
  state => state.pagination
);

export const selectHasMoreNotifications = createSelector(
  selectNotificationsState,
  state => state.hasMore
);
